/**
 * KATSEYE Decorations — scroll reveal, parallax, staggered animation delays
 */
(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     Scroll Reveal (IntersectionObserver)
     -------------------------------------------------------------------------- */
  function initScrollReveal() {
    var sections = document.querySelectorAll('.katseye-section[data-animate="true"]');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: just show everything
      sections.forEach(function (s) {
        s.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' },
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  /* --------------------------------------------------------------------------
     Hero Parallax
     -------------------------------------------------------------------------- */
  function initParallax() {
    var heroSections = document.querySelectorAll('[data-parallax="true"]');
    if (!heroSections.length) return;

    // Skip on mobile for performance
    if (window.innerWidth < 750) return;

    var ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          heroSections.forEach(updateParallax);
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  function updateParallax(hero) {
    var container = hero.querySelector('[data-parallax-container]');
    if (!container) return;

    var rect = hero.getBoundingClientRect();
    var viewH = window.innerHeight;

    // Only process when hero is in view
    if (rect.bottom < 0 || rect.top > viewH) return;

    var photos = container.querySelectorAll('[data-parallax-speed]');
    var atTop = window.scrollY <= 2;

    // Normalize scroll: 0 when hero top is at its resting position, 1 when fully past
    var scrolled = Math.max(0, window.scrollY);
    var t = Math.min(1, scrolled / rect.height);

    photos.forEach(function (photo) {
      var speed = parseFloat(photo.dataset.parallaxSpeed) || 0;
      if (speed === 0) return;

      if (atTop) {
        photo.style.transform = '';
        return;
      }

      var maxScale = 1 + (speed / 100) * 0.08;
      var maxLift = (speed / 100) * -12;
      var scale = 1 + (maxScale - 1) * t;
      var lift = maxLift * t;

      photo.style.transform = 'translateY(' + lift + 'px) scale(' + scale.toFixed(4) + ')';
    });
  }

  /* --------------------------------------------------------------------------
     Stagger Animation Delays
     -------------------------------------------------------------------------- */
  function staggerAnimationDelays() {
    var decorations = document.querySelectorAll('.katseye-decoration[data-animation]');
    decorations.forEach(function (deco, index) {
      var animation = deco.dataset.animation;
      if (!animation) return;

      // Random-ish delay so identical animations don't look synced
      var delay = (index * 0.4 + Math.random() * 0.8).toFixed(2);
      deco.style.animationDelay = delay + 's';
    });
  }

  /* --------------------------------------------------------------------------
     Init
     -------------------------------------------------------------------------- */
  function init() {
    initScrollReveal();
    initParallax();
    staggerAnimationDelays();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor re-init
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      init();
    });
  }
})();
